"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-CrossSmall" },
      _react2.default.createElement("path", { d: "M7.317 6.433L4.884 4l2.433-2.433a.625.625 0 0 0-.884-.884L4 3.116 1.567.683a.625.625 0 0 0-.884.884L3.116 4 .683 6.433a.625.625 0 0 0 .884.884L4 4.884l2.433 2.433a.625.625 0 0 0 .884-.884z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M9.317 8.433L5.884 5l3.433-3.433a.625.625 0 0 0-.884-.884L5 4.116 1.567.683a.625.625 0 0 0-.884.884C.83 1.713 2.769 3.657 4.116 5L.683 8.433a.625.625 0 0 0 .884.884L5 5.884l3.433 3.433a.625.625 0 0 0 .884-.884z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'CrossSmall';
exports.default = WrappedIcon;

